/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { acceptOffer } from '../fn/offer/accept-offer';
import { AcceptOffer$Params } from '../fn/offer/accept-offer';
import { addContactToOffer } from '../fn/offer/add-contact-to-offer';
import { AddContactToOffer$Params } from '../fn/offer/add-contact-to-offer';
import { addDiscountToArticle } from '../fn/offer/add-discount-to-article';
import { AddDiscountToArticle$Params } from '../fn/offer/add-discount-to-article';
import { addOfferSurfaces } from '../fn/offer/add-offer-surfaces';
import { AddOfferSurfaces$Params } from '../fn/offer/add-offer-surfaces';
import { addServiceToOffer } from '../fn/offer/add-service-to-offer';
import { AddServiceToOffer$Params } from '../fn/offer/add-service-to-offer';
import { addSystemToOffer } from '../fn/offer/add-system-to-offer';
import { AddSystemToOffer$Params } from '../fn/offer/add-system-to-offer';
import { applyGlobalArticleDiscounts } from '../fn/offer/apply-global-article-discounts';
import { ApplyGlobalArticleDiscounts$Params } from '../fn/offer/apply-global-article-discounts';
import { changeOfferContactRole } from '../fn/offer/change-offer-contact-role';
import { ChangeOfferContactRole$Params } from '../fn/offer/change-offer-contact-role';
import { createOffer } from '../fn/offer/create-offer';
import { CreateOffer$Params } from '../fn/offer/create-offer';
import { createOfferNoteEntry } from '../fn/offer/create-offer-note-entry';
import { CreateOfferNoteEntry$Params } from '../fn/offer/create-offer-note-entry';
import { deleteContactFromOffer } from '../fn/offer/delete-contact-from-offer';
import { DeleteContactFromOffer$Params } from '../fn/offer/delete-contact-from-offer';
import { deleteOffer } from '../fn/offer/delete-offer';
import { DeleteOffer$Params } from '../fn/offer/delete-offer';
import { deleteOfferArticle } from '../fn/offer/delete-offer-article';
import { DeleteOfferArticle$Params } from '../fn/offer/delete-offer-article';
import { deleteOfferNoteEntry } from '../fn/offer/delete-offer-note-entry';
import { DeleteOfferNoteEntry$Params } from '../fn/offer/delete-offer-note-entry';
import { deleteOfferService } from '../fn/offer/delete-offer-service';
import { DeleteOfferService$Params } from '../fn/offer/delete-offer-service';
import { downloadOffer } from '../fn/offer/download-offer';
import { DownloadOffer$Params } from '../fn/offer/download-offer';
import { getAllOfferArticles } from '../fn/offer/get-all-offer-articles';
import { GetAllOfferArticles$Params } from '../fn/offer/get-all-offer-articles';
import { getAllOfferServices } from '../fn/offer/get-all-offer-services';
import { GetAllOfferServices$Params } from '../fn/offer/get-all-offer-services';
import { getOfferArticles } from '../fn/offer/get-offer-articles';
import { GetOfferArticles$Params } from '../fn/offer/get-offer-articles';
import { getOfferArticlesGroupedByProduct } from '../fn/offer/get-offer-articles-grouped-by-product';
import { GetOfferArticlesGroupedByProduct$Params } from '../fn/offer/get-offer-articles-grouped-by-product';
import { getOfferArticlesGroupedBySystem } from '../fn/offer/get-offer-articles-grouped-by-system';
import { GetOfferArticlesGroupedBySystem$Params } from '../fn/offer/get-offer-articles-grouped-by-system';
import { getOfferConstructionSiteInfo } from '../fn/offer/get-offer-construction-site-info';
import { GetOfferConstructionSiteInfo$Params } from '../fn/offer/get-offer-construction-site-info';
import { getOfferContacts } from '../fn/offer/get-offer-contacts';
import { GetOfferContacts$Params } from '../fn/offer/get-offer-contacts';
import { getOfferMainContact } from '../fn/offer/get-offer-main-contact';
import { GetOfferMainContact$Params } from '../fn/offer/get-offer-main-contact';
import { getOfferMainInfo } from '../fn/offer/get-offer-main-info';
import { GetOfferMainInfo$Params } from '../fn/offer/get-offer-main-info';
import { getOfferNoteAttachmentDownloadUrl } from '../fn/offer/get-offer-note-attachment-download-url';
import { GetOfferNoteAttachmentDownloadUrl$Params } from '../fn/offer/get-offer-note-attachment-download-url';
import { getOfferNoteEntries } from '../fn/offer/get-offer-note-entries';
import { GetOfferNoteEntries$Params } from '../fn/offer/get-offer-note-entries';
import { getOfferNoteEntriesAuthors } from '../fn/offer/get-offer-note-entries-authors';
import { GetOfferNoteEntriesAuthors$Params } from '../fn/offer/get-offer-note-entries-authors';
import { getOfferNotes } from '../fn/offer/get-offer-notes';
import { GetOfferNotes$Params } from '../fn/offer/get-offer-notes';
import { getOfferProductConfiguration } from '../fn/offer/get-offer-product-configuration';
import { GetOfferProductConfiguration$Params } from '../fn/offer/get-offer-product-configuration';
import { getOffers } from '../fn/offer/get-offers';
import { GetOffers$Params } from '../fn/offer/get-offers';
import { getOfferService } from '../fn/offer/get-offer-service';
import { GetOfferService$Params } from '../fn/offer/get-offer-service';
import { getOfferServices } from '../fn/offer/get-offer-services';
import { GetOfferServices$Params } from '../fn/offer/get-offer-services';
import { getOffersRecap } from '../fn/offer/get-offers-recap';
import { GetOffersRecap$Params } from '../fn/offer/get-offers-recap';
import { getOfferSystemConfiguration } from '../fn/offer/get-offer-system-configuration';
import { GetOfferSystemConfiguration$Params } from '../fn/offer/get-offer-system-configuration';
import { getOfferTotalAmounts } from '../fn/offer/get-offer-total-amounts';
import { GetOfferTotalAmounts$Params } from '../fn/offer/get-offer-total-amounts';
import { MainContactResponse } from '../models/main-contact-response';
import { makeOfferContactMain } from '../fn/offer/make-offer-contact-main';
import { MakeOfferContactMain$Params } from '../fn/offer/make-offer-contact-main';
import { OfferArticlesResponse } from '../models/offer-articles-response';
import { OfferArticleSummaryResponse } from '../models/offer-article-summary-response';
import { OfferConstructionSiteInfoResponse } from '../models/offer-construction-site-info-response';
import { OfferContactResponse } from '../models/offer-contact-response';
import { OfferListResponsePaging } from '../models/offer-list-response-paging';
import { OfferMainInfoResponse } from '../models/offer-main-info-response';
import { OfferNoteAttachmentDownloadUrlResponse } from '../models/offer-note-attachment-download-url-response';
import { OfferNoteEntryCreatedByResponse } from '../models/offer-note-entry-created-by-response';
import { OfferNoteEntryResponse } from '../models/offer-note-entry-response';
import { OfferProductConfigurationResponse } from '../models/offer-product-configuration-response';
import { OfferProductsResponse } from '../models/offer-products-response';
import { OfferServiceDetailResponse } from '../models/offer-service-detail-response';
import { OfferServicesResponse } from '../models/offer-services-response';
import { OfferServicesSummaryResponse } from '../models/offer-services-summary-response';
import { OffersRecapResponse } from '../models/offers-recap-response';
import { OfferSystemConfigurationResponse } from '../models/offer-system-configuration-response';
import { OfferSystemsResponse } from '../models/offer-systems-response';
import { OfferTotalsResponse } from '../models/offer-totals-response';
import { rejectOffer } from '../fn/offer/reject-offer';
import { RejectOffer$Params } from '../fn/offer/reject-offer';
import { removeProductFromOffer } from '../fn/offer/remove-product-from-offer';
import { RemoveProductFromOffer$Params } from '../fn/offer/remove-product-from-offer';
import { removeSystemFromOffer } from '../fn/offer/remove-system-from-offer';
import { RemoveSystemFromOffer$Params } from '../fn/offer/remove-system-from-offer';
import { sendOfferAndDownload } from '../fn/offer/send-offer-and-download';
import { SendOfferAndDownload$Params } from '../fn/offer/send-offer-and-download';
import { updateArticleDiscount } from '../fn/offer/update-article-discount';
import { UpdateArticleDiscount$Params } from '../fn/offer/update-article-discount';
import { updateOfferConstructionSiteInfo } from '../fn/offer/update-offer-construction-site-info';
import { UpdateOfferConstructionSiteInfo$Params } from '../fn/offer/update-offer-construction-site-info';
import { updateOfferNotes } from '../fn/offer/update-offer-notes';
import { UpdateOfferNotes$Params } from '../fn/offer/update-offer-notes';
import { updateOfferProductSurfaces } from '../fn/offer/update-offer-product-surfaces';
import { UpdateOfferProductSurfaces$Params } from '../fn/offer/update-offer-product-surfaces';
import { updateOfferService } from '../fn/offer/update-offer-service';
import { UpdateOfferService$Params } from '../fn/offer/update-offer-service';
import { updateOfferSystem } from '../fn/offer/update-offer-system';
import { UpdateOfferSystem$Params } from '../fn/offer/update-offer-system';

@Injectable({ providedIn: 'root' })
export class OfferService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `acceptOffer()` */
  static readonly AcceptOfferPath = '/offers/{id}/accept';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `acceptOffer()` instead.
   *
   * This method doesn't expect any request body.
   */
  acceptOffer$Response(params: AcceptOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return acceptOffer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `acceptOffer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  acceptOffer(params: AcceptOffer$Params, context?: HttpContext): Observable<void> {
    return this.acceptOffer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getOfferContacts()` */
  static readonly GetOfferContactsPath = '/offers/{id}/contacts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferContacts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferContacts$Response(params: GetOfferContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OfferContactResponse>>> {
    return getOfferContacts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferContacts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferContacts(params: GetOfferContacts$Params, context?: HttpContext): Observable<Array<OfferContactResponse>> {
    return this.getOfferContacts$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OfferContactResponse>>): Array<OfferContactResponse> => r.body)
    );
  }

  /** Path part for operation `addContactToOffer()` */
  static readonly AddContactToOfferPath = '/offers/{id}/contacts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addContactToOffer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addContactToOffer$Response(params: AddContactToOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addContactToOffer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addContactToOffer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addContactToOffer(params: AddContactToOffer$Params, context?: HttpContext): Observable<void> {
    return this.addContactToOffer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addDiscountToArticle()` */
  static readonly AddDiscountToArticlePath = '/offers/{id}/articles/{articleId}/discounts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addDiscountToArticle()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addDiscountToArticle$Response(params: AddDiscountToArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addDiscountToArticle(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addDiscountToArticle$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addDiscountToArticle(params: AddDiscountToArticle$Params, context?: HttpContext): Observable<void> {
    return this.addDiscountToArticle$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getOfferArticles()` */
  static readonly GetOfferArticlesPath = '/offers/{id}/articles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferArticles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferArticles$Response(params: GetOfferArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferArticlesResponse>> {
    return getOfferArticles(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferArticles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferArticles(params: GetOfferArticles$Params, context?: HttpContext): Observable<OfferArticlesResponse> {
    return this.getOfferArticles$Response(params, context).pipe(
      map((r: StrictHttpResponse<OfferArticlesResponse>): OfferArticlesResponse => r.body)
    );
  }

  /** Path part for operation `addOfferSurfaces()` */
  static readonly AddOfferSurfacesPath = '/offers/{id}/articles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addOfferSurfaces()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addOfferSurfaces$Response(params: AddOfferSurfaces$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addOfferSurfaces(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addOfferSurfaces$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addOfferSurfaces(params: AddOfferSurfaces$Params, context?: HttpContext): Observable<void> {
    return this.addOfferSurfaces$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getOfferServices()` */
  static readonly GetOfferServicesPath = '/offers/{id}/services';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferServices()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferServices$Response(params: GetOfferServices$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferServicesResponse>> {
    return getOfferServices(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferServices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferServices(params: GetOfferServices$Params, context?: HttpContext): Observable<OfferServicesResponse> {
    return this.getOfferServices$Response(params, context).pipe(
      map((r: StrictHttpResponse<OfferServicesResponse>): OfferServicesResponse => r.body)
    );
  }

  /** Path part for operation `addServiceToOffer()` */
  static readonly AddServiceToOfferPath = '/offers/{id}/services';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addServiceToOffer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addServiceToOffer$Response(params: AddServiceToOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addServiceToOffer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addServiceToOffer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addServiceToOffer(params: AddServiceToOffer$Params, context?: HttpContext): Observable<void> {
    return this.addServiceToOffer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOfferSystem()` */
  static readonly UpdateOfferSystemPath = '/offer/{offerId}/system';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOfferSystem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOfferSystem$Response(params: UpdateOfferSystem$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateOfferSystem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOfferSystem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOfferSystem(params: UpdateOfferSystem$Params, context?: HttpContext): Observable<void> {
    return this.updateOfferSystem$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `addSystemToOffer()` */
  static readonly AddSystemToOfferPath = '/offer/{offerId}/system';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `addSystemToOffer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSystemToOffer$Response(params: AddSystemToOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return addSystemToOffer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `addSystemToOffer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  addSystemToOffer(params: AddSystemToOffer$Params, context?: HttpContext): Observable<void> {
    return this.addSystemToOffer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `applyGlobalArticleDiscounts()` */
  static readonly ApplyGlobalArticleDiscountsPath = '/offers/{id}/articles/global-discounts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `applyGlobalArticleDiscounts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  applyGlobalArticleDiscounts$Response(params: ApplyGlobalArticleDiscounts$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return applyGlobalArticleDiscounts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `applyGlobalArticleDiscounts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  applyGlobalArticleDiscounts(params: ApplyGlobalArticleDiscounts$Params, context?: HttpContext): Observable<void> {
    return this.applyGlobalArticleDiscounts$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `changeOfferContactRole()` */
  static readonly ChangeOfferContactRolePath = '/offers/{id}/contacts/{contactId}/role';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `changeOfferContactRole()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeOfferContactRole$Response(params: ChangeOfferContactRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return changeOfferContactRole(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `changeOfferContactRole$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  changeOfferContactRole(params: ChangeOfferContactRole$Params, context?: HttpContext): Observable<void> {
    return this.changeOfferContactRole$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getOffers()` */
  static readonly GetOffersPath = '/offers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOffers()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOffers$Response(params: GetOffers$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferListResponsePaging>> {
    return getOffers(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOffers$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOffers(params: GetOffers$Params, context?: HttpContext): Observable<OfferListResponsePaging> {
    return this.getOffers$Response(params, context).pipe(
      map((r: StrictHttpResponse<OfferListResponsePaging>): OfferListResponsePaging => r.body)
    );
  }

  /** Path part for operation `createOffer()` */
  static readonly CreateOfferPath = '/offers';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOffer()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOffer$Response(params: CreateOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
    return createOffer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOffer$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOffer(params: CreateOffer$Params, context?: HttpContext): Observable<number> {
    return this.createOffer$Response(params, context).pipe(
      map((r: StrictHttpResponse<number>): number => r.body)
    );
  }

  /** Path part for operation `getOfferNoteEntries()` */
  static readonly GetOfferNoteEntriesPath = '/offers/{id}/note-entries';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferNoteEntries()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferNoteEntries$Response(params: GetOfferNoteEntries$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OfferNoteEntryResponse>>> {
    return getOfferNoteEntries(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferNoteEntries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferNoteEntries(params: GetOfferNoteEntries$Params, context?: HttpContext): Observable<Array<OfferNoteEntryResponse>> {
    return this.getOfferNoteEntries$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OfferNoteEntryResponse>>): Array<OfferNoteEntryResponse> => r.body)
    );
  }

  /** Path part for operation `createOfferNoteEntry()` */
  static readonly CreateOfferNoteEntryPath = '/offers/{id}/note-entries';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOfferNoteEntry()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createOfferNoteEntry$Response(params: CreateOfferNoteEntry$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return createOfferNoteEntry(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOfferNoteEntry$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createOfferNoteEntry(params: CreateOfferNoteEntry$Params, context?: HttpContext): Observable<void> {
    return this.createOfferNoteEntry$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteContactFromOffer()` */
  static readonly DeleteContactFromOfferPath = '/offers/{id}/contacts/{contactId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteContactFromOffer()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteContactFromOffer$Response(params: DeleteContactFromOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteContactFromOffer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteContactFromOffer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteContactFromOffer(params: DeleteContactFromOffer$Params, context?: HttpContext): Observable<void> {
    return this.deleteContactFromOffer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteOffer()` */
  static readonly DeleteOfferPath = '/offers/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOffer()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOffer$Response(params: DeleteOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteOffer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOffer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOffer(params: DeleteOffer$Params, context?: HttpContext): Observable<void> {
    return this.deleteOffer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteOfferArticle()` */
  static readonly DeleteOfferArticlePath = '/offers/{id}/articles/{articleId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOfferArticle()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOfferArticle$Response(params: DeleteOfferArticle$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteOfferArticle(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOfferArticle$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOfferArticle(params: DeleteOfferArticle$Params, context?: HttpContext): Observable<void> {
    return this.deleteOfferArticle$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteOfferNoteEntry()` */
  static readonly DeleteOfferNoteEntryPath = '/offers/{id}/note-entries/{noteEntryId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOfferNoteEntry()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOfferNoteEntry$Response(params: DeleteOfferNoteEntry$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteOfferNoteEntry(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOfferNoteEntry$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOfferNoteEntry(params: DeleteOfferNoteEntry$Params, context?: HttpContext): Observable<void> {
    return this.deleteOfferNoteEntry$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateOfferService()` */
  static readonly UpdateOfferServicePath = '/offers/{id}/services/{serviceId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOfferService()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOfferService$Response(params: UpdateOfferService$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateOfferService(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOfferService$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOfferService(params: UpdateOfferService$Params, context?: HttpContext): Observable<void> {
    return this.updateOfferService$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `deleteOfferService()` */
  static readonly DeleteOfferServicePath = '/offers/{id}/services/{serviceId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteOfferService()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOfferService$Response(params: DeleteOfferService$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteOfferService(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteOfferService$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteOfferService(params: DeleteOfferService$Params, context?: HttpContext): Observable<void> {
    return this.deleteOfferService$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `downloadOffer()` */
  static readonly DownloadOfferPath = '/offers/{id}/download';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `downloadOffer()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadOffer$Response(params: DownloadOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return downloadOffer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `downloadOffer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  downloadOffer(params: DownloadOffer$Params, context?: HttpContext): Observable<Blob> {
    return this.downloadOffer$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `getAllOfferArticles()` */
  static readonly GetAllOfferArticlesPath = '/offers/{id}/articles/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllOfferArticles()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOfferArticles$Response(params: GetAllOfferArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferArticleSummaryResponse>> {
    return getAllOfferArticles(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllOfferArticles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOfferArticles(params: GetAllOfferArticles$Params, context?: HttpContext): Observable<OfferArticleSummaryResponse> {
    return this.getAllOfferArticles$Response(params, context).pipe(
      map((r: StrictHttpResponse<OfferArticleSummaryResponse>): OfferArticleSummaryResponse => r.body)
    );
  }

  /** Path part for operation `getAllOfferServices()` */
  static readonly GetAllOfferServicesPath = '/offers/{id}/services/all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllOfferServices()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOfferServices$Response(params: GetAllOfferServices$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferServicesSummaryResponse>> {
    return getAllOfferServices(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllOfferServices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllOfferServices(params: GetAllOfferServices$Params, context?: HttpContext): Observable<OfferServicesSummaryResponse> {
    return this.getAllOfferServices$Response(params, context).pipe(
      map((r: StrictHttpResponse<OfferServicesSummaryResponse>): OfferServicesSummaryResponse => r.body)
    );
  }

  /** Path part for operation `getOfferArticlesGroupedByProduct()` */
  static readonly GetOfferArticlesGroupedByProductPath = '/offers/{id}/product-articles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferArticlesGroupedByProduct()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferArticlesGroupedByProduct$Response(params: GetOfferArticlesGroupedByProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferProductsResponse>> {
    return getOfferArticlesGroupedByProduct(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferArticlesGroupedByProduct$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferArticlesGroupedByProduct(params: GetOfferArticlesGroupedByProduct$Params, context?: HttpContext): Observable<OfferProductsResponse> {
    return this.getOfferArticlesGroupedByProduct$Response(params, context).pipe(
      map((r: StrictHttpResponse<OfferProductsResponse>): OfferProductsResponse => r.body)
    );
  }

  /** Path part for operation `getOfferArticlesGroupedBySystem()` */
  static readonly GetOfferArticlesGroupedBySystemPath = '/offers/{id}/system-articles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferArticlesGroupedBySystem()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferArticlesGroupedBySystem$Response(params: GetOfferArticlesGroupedBySystem$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferSystemsResponse>> {
    return getOfferArticlesGroupedBySystem(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferArticlesGroupedBySystem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferArticlesGroupedBySystem(params: GetOfferArticlesGroupedBySystem$Params, context?: HttpContext): Observable<OfferSystemsResponse> {
    return this.getOfferArticlesGroupedBySystem$Response(params, context).pipe(
      map((r: StrictHttpResponse<OfferSystemsResponse>): OfferSystemsResponse => r.body)
    );
  }

  /** Path part for operation `getOfferConstructionSiteInfo()` */
  static readonly GetOfferConstructionSiteInfoPath = '/offers/{id}/construction-site-info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferConstructionSiteInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferConstructionSiteInfo$Response(params: GetOfferConstructionSiteInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferConstructionSiteInfoResponse>> {
    return getOfferConstructionSiteInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferConstructionSiteInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferConstructionSiteInfo(params: GetOfferConstructionSiteInfo$Params, context?: HttpContext): Observable<OfferConstructionSiteInfoResponse> {
    return this.getOfferConstructionSiteInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<OfferConstructionSiteInfoResponse>): OfferConstructionSiteInfoResponse => r.body)
    );
  }

  /** Path part for operation `updateOfferConstructionSiteInfo()` */
  static readonly UpdateOfferConstructionSiteInfoPath = '/offers/{id}/construction-site-info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOfferConstructionSiteInfo()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOfferConstructionSiteInfo$Response(params: UpdateOfferConstructionSiteInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateOfferConstructionSiteInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOfferConstructionSiteInfo$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOfferConstructionSiteInfo(params: UpdateOfferConstructionSiteInfo$Params, context?: HttpContext): Observable<void> {
    return this.updateOfferConstructionSiteInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getOfferMainContact()` */
  static readonly GetOfferMainContactPath = '/offers/{id}/contact';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferMainContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferMainContact$Response(params: GetOfferMainContact$Params, context?: HttpContext): Observable<StrictHttpResponse<MainContactResponse>> {
    return getOfferMainContact(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferMainContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferMainContact(params: GetOfferMainContact$Params, context?: HttpContext): Observable<MainContactResponse> {
    return this.getOfferMainContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<MainContactResponse>): MainContactResponse => r.body)
    );
  }

  /** Path part for operation `getOfferMainInfo()` */
  static readonly GetOfferMainInfoPath = '/offers/{id}/main-info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferMainInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferMainInfo$Response(params: GetOfferMainInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferMainInfoResponse>> {
    return getOfferMainInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferMainInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferMainInfo(params: GetOfferMainInfo$Params, context?: HttpContext): Observable<OfferMainInfoResponse> {
    return this.getOfferMainInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<OfferMainInfoResponse>): OfferMainInfoResponse => r.body)
    );
  }

  /** Path part for operation `getOfferNoteAttachmentDownloadUrl()` */
  static readonly GetOfferNoteAttachmentDownloadUrlPath = '/offers/{id}/note-entries/{noteEntryId}/attachments/{attachmentId}/download-url';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferNoteAttachmentDownloadUrl()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferNoteAttachmentDownloadUrl$Response(params: GetOfferNoteAttachmentDownloadUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferNoteAttachmentDownloadUrlResponse>> {
    return getOfferNoteAttachmentDownloadUrl(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferNoteAttachmentDownloadUrl$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferNoteAttachmentDownloadUrl(params: GetOfferNoteAttachmentDownloadUrl$Params, context?: HttpContext): Observable<OfferNoteAttachmentDownloadUrlResponse> {
    return this.getOfferNoteAttachmentDownloadUrl$Response(params, context).pipe(
      map((r: StrictHttpResponse<OfferNoteAttachmentDownloadUrlResponse>): OfferNoteAttachmentDownloadUrlResponse => r.body)
    );
  }

  /** Path part for operation `getOfferNoteEntriesAuthors()` */
  static readonly GetOfferNoteEntriesAuthorsPath = '/offers/{id}/note-entries/authors';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferNoteEntriesAuthors()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferNoteEntriesAuthors$Response(params: GetOfferNoteEntriesAuthors$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OfferNoteEntryCreatedByResponse>>> {
    return getOfferNoteEntriesAuthors(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferNoteEntriesAuthors$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferNoteEntriesAuthors(params: GetOfferNoteEntriesAuthors$Params, context?: HttpContext): Observable<Array<OfferNoteEntryCreatedByResponse>> {
    return this.getOfferNoteEntriesAuthors$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<OfferNoteEntryCreatedByResponse>>): Array<OfferNoteEntryCreatedByResponse> => r.body)
    );
  }

  /** Path part for operation `getOfferNotes()` */
  static readonly GetOfferNotesPath = '/offers/{id}/notes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferNotes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferNotes$Response(params: GetOfferNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return getOfferNotes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferNotes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferNotes(params: GetOfferNotes$Params, context?: HttpContext): Observable<string> {
    return this.getOfferNotes$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `updateOfferNotes()` */
  static readonly UpdateOfferNotesPath = '/offers/{id}/notes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOfferNotes()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOfferNotes$Response(params: UpdateOfferNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateOfferNotes(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOfferNotes$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOfferNotes(params: UpdateOfferNotes$Params, context?: HttpContext): Observable<void> {
    return this.updateOfferNotes$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getOfferProductConfiguration()` */
  static readonly GetOfferProductConfigurationPath = '/offers/{id}/product-articles/{productId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferProductConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferProductConfiguration$Response(params: GetOfferProductConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferProductConfigurationResponse>> {
    return getOfferProductConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferProductConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferProductConfiguration(params: GetOfferProductConfiguration$Params, context?: HttpContext): Observable<OfferProductConfigurationResponse> {
    return this.getOfferProductConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<OfferProductConfigurationResponse>): OfferProductConfigurationResponse => r.body)
    );
  }

  /** Path part for operation `updateOfferProductSurfaces()` */
  static readonly UpdateOfferProductSurfacesPath = '/offers/{id}/product-articles/{productId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateOfferProductSurfaces()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOfferProductSurfaces$Response(params: UpdateOfferProductSurfaces$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateOfferProductSurfaces(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateOfferProductSurfaces$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateOfferProductSurfaces(params: UpdateOfferProductSurfaces$Params, context?: HttpContext): Observable<void> {
    return this.updateOfferProductSurfaces$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getOfferService()` */
  static readonly GetOfferServicePath = '/offers/{id}/services/{extraServiceId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferService()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferService$Response(params: GetOfferService$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferServiceDetailResponse>> {
    return getOfferService(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferService$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferService(params: GetOfferService$Params, context?: HttpContext): Observable<OfferServiceDetailResponse> {
    return this.getOfferService$Response(params, context).pipe(
      map((r: StrictHttpResponse<OfferServiceDetailResponse>): OfferServiceDetailResponse => r.body)
    );
  }

  /** Path part for operation `getOffersRecap()` */
  static readonly GetOffersRecapPath = '/offers/recap';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOffersRecap()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOffersRecap$Response(params: GetOffersRecap$Params, context?: HttpContext): Observable<StrictHttpResponse<OffersRecapResponse>> {
    return getOffersRecap(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOffersRecap$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOffersRecap(params: GetOffersRecap$Params, context?: HttpContext): Observable<OffersRecapResponse> {
    return this.getOffersRecap$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffersRecapResponse>): OffersRecapResponse => r.body)
    );
  }

  /** Path part for operation `getOfferSystemConfiguration()` */
  static readonly GetOfferSystemConfigurationPath = '/offers/{offerId}/systems/{systemVariantId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferSystemConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferSystemConfiguration$Response(params: GetOfferSystemConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferSystemConfigurationResponse>> {
    return getOfferSystemConfiguration(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferSystemConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferSystemConfiguration(params: GetOfferSystemConfiguration$Params, context?: HttpContext): Observable<OfferSystemConfigurationResponse> {
    return this.getOfferSystemConfiguration$Response(params, context).pipe(
      map((r: StrictHttpResponse<OfferSystemConfigurationResponse>): OfferSystemConfigurationResponse => r.body)
    );
  }

  /** Path part for operation `getOfferTotalAmounts()` */
  static readonly GetOfferTotalAmountsPath = '/offers/{id}/totals';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getOfferTotalAmounts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferTotalAmounts$Response(params: GetOfferTotalAmounts$Params, context?: HttpContext): Observable<StrictHttpResponse<OfferTotalsResponse>> {
    return getOfferTotalAmounts(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getOfferTotalAmounts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getOfferTotalAmounts(params: GetOfferTotalAmounts$Params, context?: HttpContext): Observable<OfferTotalsResponse> {
    return this.getOfferTotalAmounts$Response(params, context).pipe(
      map((r: StrictHttpResponse<OfferTotalsResponse>): OfferTotalsResponse => r.body)
    );
  }

  /** Path part for operation `makeOfferContactMain()` */
  static readonly MakeOfferContactMainPath = '/offers/{id}/contacts/{contactId}/main';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `makeOfferContactMain()` instead.
   *
   * This method doesn't expect any request body.
   */
  makeOfferContactMain$Response(params: MakeOfferContactMain$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return makeOfferContactMain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `makeOfferContactMain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  makeOfferContactMain(params: MakeOfferContactMain$Params, context?: HttpContext): Observable<void> {
    return this.makeOfferContactMain$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `rejectOffer()` */
  static readonly RejectOfferPath = '/offers/{id}/reject';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rejectOffer()` instead.
   *
   * This method doesn't expect any request body.
   */
  rejectOffer$Response(params: RejectOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return rejectOffer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `rejectOffer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  rejectOffer(params: RejectOffer$Params, context?: HttpContext): Observable<void> {
    return this.rejectOffer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeProductFromOffer()` */
  static readonly RemoveProductFromOfferPath = '/offers/{offerId}/product-articles/{productId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeProductFromOffer()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeProductFromOffer$Response(params: RemoveProductFromOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeProductFromOffer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeProductFromOffer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeProductFromOffer(params: RemoveProductFromOffer$Params, context?: HttpContext): Observable<void> {
    return this.removeProductFromOffer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeSystemFromOffer()` */
  static readonly RemoveSystemFromOfferPath = '/offers/{offerId}/systems/{systemId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeSystemFromOffer()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeSystemFromOffer$Response(params: RemoveSystemFromOffer$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return removeSystemFromOffer(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeSystemFromOffer$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeSystemFromOffer(params: RemoveSystemFromOffer$Params, context?: HttpContext): Observable<void> {
    return this.removeSystemFromOffer$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `sendOfferAndDownload()` */
  static readonly SendOfferAndDownloadPath = '/offers/{id}/send';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendOfferAndDownload()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendOfferAndDownload$Response(params: SendOfferAndDownload$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return sendOfferAndDownload(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sendOfferAndDownload$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sendOfferAndDownload(params: SendOfferAndDownload$Params, context?: HttpContext): Observable<Blob> {
    return this.sendOfferAndDownload$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `updateArticleDiscount()` */
  static readonly UpdateArticleDiscountPath = '/offers/{id}/articles/{articleId}/discounts/{index}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateArticleDiscount()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateArticleDiscount$Response(params: UpdateArticleDiscount$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return updateArticleDiscount(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateArticleDiscount$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateArticleDiscount(params: UpdateArticleDiscount$Params, context?: HttpContext): Observable<void> {
    return this.updateArticleDiscount$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
